<template>
  <v-container>
    <ShowcaseOperationsExecution
      :showcase="showcase"
    ></ShowcaseOperationsExecution>
    <ShowcaseOperationsList :showcase="showcase"></ShowcaseOperationsList>
    <ScheduledOperationsList :showcase="showcase"></ScheduledOperationsList>
  </v-container>
</template>

<script>
import ShowcaseOperationsList from './ShowcaseOperationsList'
import ScheduledOperationsList from './ScheduledOperationsList'
import ShowcaseOperationsExecution from './ShowcaseOperationsExecution'
import moment from 'moment'
export default {
  name: 'ShowcaseOperations',
  components: {
    ShowcaseOperationsList,
    ScheduledOperationsList,
    ShowcaseOperationsExecution
  },
  data: () => ({}),
  props: ['showcase'],
  methods: {
    statusIcon: function(status) {
      return status ? status.color : 'black'
    },
    formatDate: function(date) {
      return moment
        .utc(date)
        .local()
        .format('DD.MM.YY, HH:mm:ss')
    }
  }
}
</script>

<style scoped></style>
